var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairnessOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 1.89543 11.1046 1 10 1C8.89543 1 8 1.89543 8 3V16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16V3Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C11.5 2.17157 10.8284 1.5 10 1.5C9.17157 1.5 8.5 2.17157 8.5 3V16C8.5 16.8284 9.17157 17.5 10 17.5C10.8284 17.5 11.5 16.8284 11.5 16V3Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H16C17.0609 16 18.0783 16.4214 18.8284 17.1716C19.5786 17.9217 20 18.9391 20 20H0C0 18.9391 0.421427 17.9217 1.17157 17.1716C1.92172 16.4214 2.93913 16 4 16V16Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16.5H16.5C17.2956 16.5 18.0587 16.8161 18.6213 17.3787C19.1839 17.9413 19.5 18.7044 19.5 19.5V19.5H0.5C0.5 18.7044 0.81607 17.9413 1.37868 17.3787C1.94129 16.8161 2.70435 16.5 3.5 16.5V16.5Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.98047H17.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9502 4C11.0548 4 11.9502 3.10457 11.9502 2C11.9502 0.89543 11.0548 0 9.9502 0C8.84563 0 7.9502 0.89543 7.9502 2C7.9502 3.10457 8.84563 4 9.9502 4Z",
    fill: "#AECDFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9502 3.5C10.7786 3.5 11.4502 2.82843 11.4502 2C11.4502 1.17157 10.7786 0.5 9.9502 0.5C9.12177 0.5 8.4502 1.17157 8.4502 2C8.4502 2.82843 9.12177 3.5 9.9502 3.5Z",
    stroke: "#AFCEFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5V8.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5V8.5",
    stroke: "#272D55",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2443 11.4953H13.8623L15.5533 8.11328L17.2443 11.4953Z",
    fill: "#AECDFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5531 9.23188L14.6711 10.9958H16.4351L15.5531 9.23188ZM15.5531 7.49023C15.6951 7.49023 15.8372 7.56394 15.9109 7.71135L17.7637 11.4169C17.8966 11.6829 17.7032 11.9958 17.4059 11.9958H13.7003C13.403 11.9958 13.2096 11.6829 13.3425 11.4169L15.1953 7.71135C15.269 7.56394 15.4111 7.49023 15.5531 7.49023Z",
    fill: "#AECDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19155 11.4992H2.80957L4.50056 8.11719L6.19155 11.4992Z",
    fill: "#AECDFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50037 9.23579L3.61841 10.9997H5.38234L4.50037 9.23579ZM4.50038 7.49414C4.64241 7.49414 4.78444 7.56785 4.85815 7.71526L6.71094 11.4208C6.84391 11.6868 6.65052 11.9997 6.35317 11.9997H2.64759C2.35024 11.9997 2.15684 11.6868 2.28982 11.4208L4.14261 7.71526C4.21631 7.56785 4.35834 7.49414 4.50038 7.49414Z",
    fill: "#AECDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairnessOperationIcon);
export default __webpack_public_path__ + "static/media/FairnessOperationIcon.214a0f5a7adaf9a42641475678b97e87.svg";
export { ForwardRef as ReactComponent };